import { Protocol } from '../Protocol';

export class ReportProtocol {
  public static readonly REPORT_SIEVE: string = `${Protocol.YATUNG_API_ROOT}/report/sieve`;
  public static readonly SEARCH_SIEVE_REPORT: string = `${Protocol.YATUNG_API_ROOT}/report/sieve/search`;
}
